	<div class="t-popup popup-patientDetails"  style='display: block'>

    <div class="t-popup-close"></div>
    
    <div class="t-popup-frame" [ngClass]="export ? 'mrg' : ''" >
        <div class="t-popup-body">

            <button class="t-btn-popup-close" aria-label="close popup" (click)="closed.emit()"></button>

            <div class="login-form">
                <div *ngIf="loginService.loginError" class="strong">{{loginService.loginError}}</div>
				<div class="login-form-row" *ngIf="! loginService.getCode && (loginService.requireExamLogon || ! loginService.localServer)">
					<input class="login-form-field focusOnParent" type="text" placeholder="User Name" aria-label="user name" [(ngModel)]="user" autocomplete="off" (keyup.enter)="examService.isLoginForEdit = false; checkLogin()" (keyup)="clean()"/>
					<i class="login-form-icon icon-userName"></i>
				</div>

				<div class="login-form-row" *ngIf="! loginService.getCode && (loginService.requireExamLogon || ! loginService.localServer)">
					<input class="login-form-field focusOnParent" [type]="hidepw ? 'password' : 'text'" placeholder="Password" aria-label="password" [(ngModel)]="pw" (keyup.enter)="examService.isLoginForEdit = false; checkLogin()" (keyup)="clean()" autocomplete="off" (focus)="typed=true"/>
					<i class="login-form-icon {{! typed ? 'icon-password' : (hidepw ? 'icon-openpw' : 'icon-closepw')}}" (click)="hidepw=!hidepw"></i>
				</div>

    		<!-- =============== Login for Edit (Start) =============== -->
				<input *ngIf="(signatureService.isExamSigned(examService.examObject)) && !hideButton && (loginService.requireExamLogon || !loginService.localServer) && !search && !newexam" type="submit" class="login-form-submit t-btn-grad" (keyup.enter)="checkLogin(true); examService.isLoginForEdit = true;" value="Login for Edit" (click)="checkLogin(true); examService.isLoginForEdit = true;"/>
				<!-- =============== Login for Edit (End) =============== -->

				<!-- =============== Login (Start) =============== -->
				<input *ngIf="(!signatureService.isExamSigned(examService.examObject) || newexam) && !hideButton && (loginService.requireExamLogon || ! loginService.localServer) && !search" type="submit" class="login-form-submit t-btn-grad" (keyup.enter)="checkLogin()" value="Login" (click)="examService.isLoginForEdit = false; checkLogin()"/>
				<!-- =============== Login (End) =============== -->

				<!-- =============== Edit As (Start) =============== -->
				<input *ngIf="! loginService.requireExamLogon && loginService.localServer && !export && ! hideButton" type="submit" class="login-form-submit t-btn-grad" (keyup.enter)="loginService.loginAsCurrentUser()" value="Edit as {{loginService.username}}" (click)="hideButton=true;loginService.loginAsCurrentUser()"/>
				<!-- =============== Edit As (End) =============== -->

				<br>

				<!-- =============== View Only (Start) =============== -->
				<input *ngIf="(!newexam && !export && signatureService.isExamSigned(examService.examObject)) || search" type="submit" class="login-form-submit t-btn-grad" value="VIEW ONLY" (click)="examService.isSignAndPrint = false; viewonly.emit()" style='margin-top:1em'/>
				<!-- =============== View Only (End) =============== -->

				<div class="login-form-row" *ngIf="loginService.exportLoading">
					<span>Downloading...</span>
				</div>
				
			</div>        
        </div>
    </div>

</div>

